import {LocationWithWeather} from '@/app/interfaces/weather';
import {LocationPoint} from '@/common/interfaces/location';
import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {selectForecastLocation} from '@/app/store/forecast/selectors';
import {settlementExtraDataFetcher} from '@/app/store/forecast/actions/helpers/settlementExtraDataFetcher';

/**
 * An action that requires an extra data of the weather page for a settlement.
 * Used by navigation within the settlement of the main page */
export const fetchSettlementExtraDataAction = createAsyncThunk<
	{
		language: string;
	},
	{
		regionTopLocationWeather: LocationWithWeather[];
		countryTopLocations: LocationPoint[];
	}
>('forecast/fetchSettlementExtraData', async (params, {context, getState, success, failure}) => {
	const {language} = params;
	const location = selectForecastLocation(getState())!;

	const lists = await settlementExtraDataFetcher({
		language,
		location,
		context,
		getState,
	});

	// Check the required data is up-to-date after the request is completed
	if (location.superior.region?.id !== selectForecastLocation(getState())?.superior.region?.id) {
		return failure();
	}

	return success(lists);
});
